module.exports = __webpack_public_path__ + "img/three3Red.e81c8d9c.png";